<template>
  <v-app>
    <PublicHeader/>
    <v-main>
      <v-container class="px-0" fluid>
        <v-parallax
          src="@/assets/workfromhome.jpeg"
        >
          <v-row
            align="center"
            justify="center"
          >
            <v-col
              class="text-center"
              cols="12"
            >
              <h1 class="text-h2">We're here to help</h1>
            </v-col>
          </v-row>
        </v-parallax>
        <v-row class="mt-10" justify="center">
            <v-col cols="8" class="font-weight-light">
                <div class="text-h5 font-weight-medium">Help & Support</div>
                <div class="mt-3">Our team of highly skilled consultants is here to help you get the most out of using Ravenpod. Please email us at <a href="support@ravenpod.com">support@ravenpod.com</a></div>
            </v-col>
        </v-row>
        <v-row class="my-10" justify="center">
            <v-col cols="8" class="font-weight-light">
                <div class="text-h5 font-weight-medium">General Questions</div>
                <div class="mt-3">Have any questions? We'd love to hear from you. Please email us at <a href="help@ravenpod.com">help@ravenpod.com</a></div>
            </v-col>
        </v-row>
      </v-container>
    </v-main>
    <Footer/>
  </v-app>
</template>

<script>

  import Footer from '@/components/Footer.vue'
  import PublicHeader from '@/components/PublicHeader.vue'

  export default {
      components: {
        PublicHeader, Footer
      },
      data() {
          return {
          };
      },
      computed: {
      },
      created() {
      },
      methods: {
      }
  };

</script>

<style scoped lang="scss">

.darken {
    filter: brightness(50%);    
}    
</style>

